const React = require('react')
const { ContextProvider } = require('./src/components/context')

exports.wrapRootElement = ({ element }) => <ContextProvider>{element}</ContextProvider>
